import React, { Fragment } from "react";
import Container from "../components/Container";
import OwlError from "./../assets/img/Page404/owlerror.svg"
import { dashboardColors, theme } from "../themes/Theme";

const Page404 = () => {
  return (
    <Fragment>
      <div className="error_page">
        <div className="overlay">
          <div className="row min-vh-100">
            <div className="col-lg-5 col-md-5 offset-md-1 col-sm-12 col-xs-12 error_section">
              <span className="error_code">404</span>
              <div className="error_placehlder mb-3">
                <span className="error_message"> Oops! Something Went{" "}
                  <span className="error_wrong_text"> Wrong </span>
                </span>
                <img src="/assets/img/Page404/yellowbeansplat.svg" className="yellowbeansplat" alt="pattern" />
              </div>
              <span className="error_dec">
                {" "}
                We are very sorry for the inconvenience. It looks you are
                trying to access a page that either has been deleted or did not exist!
              </span>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 error_section  error_section-image">
              <img src={OwlError} alt="error" className="w-75" />
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .error_page {
          background:  ${dashboardColors[theme].primary}; url(/assets/img/Page404/404.svg);
          height: 100vh;
        }
        .overlay {
          position: relative;
          background: rgba(87, 33, 72, 0.98);
          height: 100vh;
        }

        .error_section{
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .error_section-image{
          align-items: center;
        }
        .error_placehlder{
          position: relative;
        }
        .error_code {
          font-family: Prompt;
          font-weight: bold;
          font-size: 10rem;
          line-height: 10rem;
          color: #f2534c;
          display: block;
        }

        .error_message {
          display: block;
          font-family: Prompt;
          font-weight: bold;
          font-size: 2rem;
          line-height: 2.5rem;
          color: #ffffff;
        }

        .error_wrong_text {
          font-family: Caveat Brush;
          font-weight: normal;
          font-size: 2.5rem;
          line-height: 3rem;
          color: #f2534c;
        }

        .error_dec {
          display: block;
          font-family: Prompt;
          font-weight: normal;
          font-size: 1.5rem;
          line-height: 2rem;
          color: #ffffff;
        }

        .yellowbeansplat{
          position: absolute;
          height: 50px;
          top: 19px;
          left: -36px;
          opacity: 0.6;
        }
      `}</style>
    </Fragment>
  );
};

export default Page404;
